// ============================================
// Leka — Spinner
// ============================================

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  dark?: boolean
}

const sizes = {
  sm: 'w-4 h-4 border-[2px]',
  md: 'w-6 h-6 border-[2.5px]',
  lg: 'w-10 h-10 border-[3px]',
}

export function Spinner({ size = 'md', dark = false }: SpinnerProps) {
  return (
    <span
      className={`inline-block rounded-full animate-spin ${sizes[size]} ${
        dark ? 'border-gray-300 border-t-gray-700' : 'border-white/20 border-t-white'
      }`}
      role="status"
      aria-label="Loading"
    />
  )
}
